import yaml from 'js-yaml';

export type ConfigType = 'tenant-aware' | 'manual';

export type ParamType =
  | 'tenant-select'
  | 'dynamic-select'
  | 'boolean'
  | 'string'
  | 'number'
  | 'choice';

export interface ParamDefinition {
  type?: ParamType | string;
  source?: string;
  path?: string;
  depends_on?: string[];
  required?: boolean;
  default?: string;
  label?: string;
  hidden?: boolean;
  choices?: string[];
  visible_when?: { param: string; equals: string | string[] };
}

export interface MergeRule {
  at: string;
  from_master?: string;
  from_tenant?: string;
  as?: string;
}

export interface PathEntry {
  merge?: MergeRule[];
  master_paths?: string[] | string;
  tenant_paths?: string[] | string;
  config_prefix?: string;
  tenant_required?: boolean;
  config_type?: ConfigType | string;
  params?: Record<string, ParamDefinition>;
  category?: string;
}

export type DefaultParamsDoc = {
  version?: string;
  global_params?: Record<string, ParamDefinition>;
  workflows?: Record<string, PathEntry>;
  cli_commands?: Record<string, PathEntry>;
};

export function parseDefaultParamsYaml(content: string): DefaultParamsDoc {
  const parsed = yaml.load(content);
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
    throw new Error('Default params YAML must be a mapping at the root');
  }
  return parsed as DefaultParamsDoc;
}

export function defaultParamsDocToYaml(doc: DefaultParamsDoc): string {
  return yaml.dump(doc, { lineWidth: 120, noRefs: true, skipInvalid: true });
}

export {
  cloneDoc,
  ensureObject,
  ensureArray,
  asString,
  asBool,
  objectRecord,
  objectMap,
  stringList,
} from './tenant-config-form-utils';
